import React, { FC, useRef } from 'react';
import * as styles from './MapLink.scss';
import { useAppSelector } from 'app/hooks/appHooks';
import { localeSelector, themeSelector } from 'app/store/selectors';
import globalThumbnail from './assets/global.png';
import trThumbnail from './assets/tr.png';
import ghThumbnail from './assets/gh.png';
import indiaThumbnail from './assets/india.png';
import brazilThumbnail from './assets/brazil.png';
import usThumbnail from './assets/us.png';
import cn from 'classnames';

export type MapLinkProps = {
  title: string;
  text: string;
};

export const MapLink: FC<MapLinkProps> = ({ title, text }) => {
  const theme = useAppSelector(themeSelector);
  const locale = useAppSelector(localeSelector);
  const ref = useRef<HTMLDivElement>(null);
  const isIndiaLocale = locale === 'en_IN';
  const isBrazilLocale = locale === 'pt_BR';
  const isUSLocale = locale === 'en_US' || locale === 'es_US' || locale === 'zh_US';
  const isMexicanLocale = locale === 'es_MX';

  const getMapImage = () => {
    if (isIndiaLocale) {
      return indiaThumbnail;
    }

    if (isBrazilLocale) {
      return brazilThumbnail;
    }

    if ((isUSLocale || isMexicanLocale) && theme !== 'neptune') {
      return usThumbnail;
    }

    switch (theme) {
      case 'neptune':
        return ghThumbnail;
      case 'kamil':
        return trThumbnail;
      default:
        return globalThumbnail;
    }
  };

  return (
    <div ref={ref} className={styles.mapWrapper}>
      <div className={styles.mapLink}>
        <div className={styles.imageWrapper}>
          <img className={styles.image} src={getMapImage()} alt="explore map" />
        </div>

        <div>
          <p className={styles.title}>{title}</p>
          <span className={cn(styles.fakeLink, { [styles.isNeptune]: theme === 'neptune' })}>
            {text}
          </span>
        </div>
      </div>
    </div>
  );
};
